import { default as indexDpPBMsCY2iMeta } from "/vercel/path0/pages/audit-log/index.vue?macro=true";
import { default as indexuedj0fLb5OMeta } from "/vercel/path0/pages/events/index.vue?macro=true";
import { default as indexj2pHbmaGTEMeta } from "/vercel/path0/pages/flagged-emails/index.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as logint0AWlhQgM0Meta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as _91sessionId_93ONUkELVZveMeta } from "/vercel/path0/pages/sessions/[sessionId].vue?macro=true";
import { default as indexjxgp28ZV52Meta } from "/vercel/path0/pages/sessions/index.vue?macro=true";
import { default as indexSFCbSdUFWMMeta } from "/vercel/path0/pages/workspaces/index.vue?macro=true";
export default [
  {
    name: "audit-log",
    path: "/audit-log",
    meta: indexDpPBMsCY2iMeta || {},
    component: () => import("/vercel/path0/pages/audit-log/index.vue")
  },
  {
    name: "events",
    path: "/events",
    meta: indexuedj0fLb5OMeta || {},
    component: () => import("/vercel/path0/pages/events/index.vue")
  },
  {
    name: "flagged-emails",
    path: "/flagged-emails",
    meta: indexj2pHbmaGTEMeta || {},
    component: () => import("/vercel/path0/pages/flagged-emails/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: logint0AWlhQgM0Meta || {},
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "sessions-sessionId",
    path: "/sessions/:sessionId()",
    meta: _91sessionId_93ONUkELVZveMeta || {},
    component: () => import("/vercel/path0/pages/sessions/[sessionId].vue")
  },
  {
    name: "sessions",
    path: "/sessions",
    meta: indexjxgp28ZV52Meta || {},
    component: () => import("/vercel/path0/pages/sessions/index.vue")
  },
  {
    name: "workspaces",
    path: "/workspaces",
    meta: indexSFCbSdUFWMMeta || {},
    component: () => import("/vercel/path0/pages/workspaces/index.vue")
  }
]